// Global state to track which component is active
let activeComponent = null;

document.addEventListener("DOMContentLoaded", () => {
  // Cart Drawer
  const cartDrawer = document.getElementById("cart-drawer");

  let timeoutCart;
  //Open Cart Drawer
  const openCartDrawer = () => {
    if (cartDrawer.classList.contains("open")) return;
    cartDrawer.classList.add("open");
    mainOverlay.classList.add("active");

    if (activeComponent === "search") closeSearch();
    if (activeComponent === "menu") toggleMenu();

    activeComponent = "cart";

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    lockHeaderVisibility();

    // Set header state if not fixed
    if (!isFixed && isTransparentEnabled) {
      timeoutCart = setTimeout(() => {
        defaultHeader();
      }, 16);
    }

    // Add overlay click handler only once
    if (!overlayClickHandler) {
      overlayClickHandler = (e) => {
        if (e.target === mainOverlay) {
          closeCartDrawer();
        }
      };
      mainOverlay.addEventListener("click", overlayClickHandler);
    }
  };

  //Close Cart Drawer
  const closeCartDrawer = () => {
    if (!cartDrawer.classList.contains("open")) return;
    cartDrawer.classList.remove("open");
    mainOverlay.classList.remove("active");
    document.body.style.overflow = "";
    activeComponent = null;

    if (isTransparentEnabled) {
      initializeHeader(window.scrollY);
      clearTimeout(timeoutCart);
    }

    // Remove overlay click handler
    if (overlayClickHandler) {
      mainOverlay.removeEventListener("click", overlayClickHandler);
      overlayClickHandler = null;
    }

    unlockHeaderVisibility();
  };

  // Modified escape key handler
  const handleEscapeKey = (e) => {
    if (e.key === "Escape") {
      if (activeComponent === "cart") {
        closeCartDrawer();
      }
    }
  };

  // Add escape key listener once
  document.addEventListener("keydown", handleEscapeKey);

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.activeComponent = activeComponent;
});
